import MessengerUI from "components/messenger/MessengerUI";
import withMessenger from "components/messenger/withMessenger";
import { AppContext } from "data/AppContextContainer";
import { useSendMessageMutation } from "data/conversation/endpoints";
import { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useIsMounted } from "utils/useIsMounted";

import { getReservationSource } from "./getReservationSource";

export const MultiplatMessenger = withMessenger(
  ({
    booking,
    getDevConfirmation,
    guestName,
    handleReset,
    handleSendStart,
    messengerUIProps,
    message,
    thread,
    update
  }) => {
    const { showNotification } = useContext(AppContext);
    const { conversationId } = useParams();
    const isMounted = useIsMounted();

    const [sendMessage, { isLoading: isSending, isSuccess, isError }] =
      useSendMessageMutation();

    const handleSendMessage = async () => {
      if (!getDevConfirmation()) {
        return;
      }

      handleSendStart();

      await sendMessage({
        conversationId,
        message,
        reservationSource: getReservationSource(booking, thread)
      });

      if (isMounted) {
        handleReset();
        update();
      }
    };

    useEffect(() => {
      if (isSuccess) {
        showNotification({
          title: `Message sent successfully to ${guestName}.`
        });
      }
    }, [isSuccess]);

    useEffect(() => {
      if (isError) {
        showNotification({
          title: `Sending message to ${guestName} failed.`,
          message: "Please try again.",
          type: "negative"
        });
      }
    }, [isError]);

    return (
      <MessengerUI
        {...messengerUIProps}
        handleSendMessage={handleSendMessage}
        sending={isSending}
      />
    );
  }
);
